import React from 'react';
import { Outlet } from 'react-router-dom';
import PreviousLocationProvider from '../PreviousLocationProvider';

/* The original react-router-last-location package that was used, is
   now deprecated and doesn't support Router v6 -- therefore, I had to
   create this custom solution.  */
const PreviousLocationLayout = () => (
  <>
    <PreviousLocationProvider>
      <Outlet />
    </PreviousLocationProvider>
  </>
);

export default PreviousLocationLayout;
